import Link from '@eliadmin/core/src/components/link';
import React from 'react';

import type {
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../ui/paragraph';
import { getSafeHref } from '@eliadmin/core/src/utils/url-utils';

export type TopbarProps = {
  locale?: string;
  generalLayout: GeneralLayout['data'];
  menu?: Menu;
};

export function Topbar({ generalLayout, menu }: TopbarProps) {
  if (!menu?.fields?.length && !generalLayout.header?.top_bar_text) return null;

  return (
    <div className={cn('custom-section', 'w-full bg-primary')}>
      <div className={cn('custom-container', 'flex h-[42px] items-center justify-between')}>
        <Paragraph
          innerHtml={generalLayout.header?.top_bar_text}
          color="white"
          className={cn('ea-topbar__text')}
        />
        <div className="hidden items-center justify-end gap-6 md:flex xl:gap-8">
          {menu?.fields?.map(item => (
            <Link
              key={item.name}
              href={getSafeHref(item?.path ?? '#')}
              className="generic-hover text-sm font-semibold text-white"
            >
              {item.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
